module.exports = __webpack_public_path__ + "img/s1.3deb26a8.png";